import { useIntl } from "react-intl";
import { Space } from "@masterteam/mt-design-react";
import moment from "moment";
import { useSelector } from "react-redux";

import Table from "../../NewTable";

import { useIsAr } from "../../../Hooks";
import { formatDate } from "../../../helpers";

import "./style.scss";

function History({ readOnly, data = [] }) {
  const intl = useIntl();
  const [isAr] = useIsAr();

  const statuses = useSelector(
    (store) => store.theme.WorkflowStatus.item.Items
  );

  const columns = [
    {
      key: "Status",
      cell: (item) => {
        const statusObj = statuses?.find(
          (e) => e?.Value?.toString() === item?.Status?.toString()
        );

        return isAr ? statusObj?.Arabic : statusObj?.English;
      },
      header: intl.formatMessage({
        id: "history.status"
      }),
      width: "20%"
    },
    {
      key: "Creator",
      cell: (item) => item?.ActionByModel?.DisplayName || "---",
      header: intl.formatMessage({
        id: "history.creator"
      }),
      width: "20%"
    },
    {
      key: "ActionDate",
      cell: (item) => {
        return item?.ActionDate ? item?.ActionDate : "---";
      },
      header: intl.formatMessage({ id: "history.action-date" }),
      width: "15%"
    },
    {
      key: "ActionTime",
      cell: (item) => (item?.ActionTime ? item?.ActionTime : "---"),
      header: intl.formatMessage({
        id: "history.action-time"
      }),
      width: "15%"
    },
    {
      key: "Comments",
      cell: (item) => item?.Comment,
      header: intl.formatMessage({
        id: "history.comments"
      }),
      width: "30%"
    }
  ];
  const actions = [];

  return (
    <Space className="history-container">
      <Table
        data={data}
        columns={columns}
        actions={readOnly ? [] : actions}
        headerHasBackgroundColor
      />
    </Space>
  );
}

export default History;
